export default "__VITE_ASSET__H92_1ON9__"